module.exports = __webpack_public_path__ + "static/media/Source Info.a542c03b.txt";